export default __webpack_public_path__ + "b13d9a6c1d754bb954a6ad868b0c8818.svg";